/* eslint-disable import/no-anonymous-default-export */
import { Button, Form, Input, notification, Select, Space, Table } from "antd";
import { FilterValue } from "antd/lib/table/interface";
import moment from "moment";
import { useRef, useState } from "react";
import DataFilter from "../common/components/DataFilter";
import DataTable, { DataTableRef } from "../common/components/DataTable";
import MainLayout from "../common/components/MainLayout";
import useInfraccionesRadarAPI from "../infracciones/hooks/useInfraccionesAPI";
import FiltroInfracciones, { FiltroInfraccionesRef } from "../infracciones/components/FiltroInfracciones";
import useLotesActaAPI, { LoteExportacion } from "./useLotesExportacionAPI";
import { FilePdfOutlined, DownloadOutlined } from '@ant-design/icons';
import { Query } from "../common/hooks/useApi";
import { TipoExportacion } from "../configuraciones-produccion/useConfiguracionesProduccionAPI";

export default () => {
    const api = useLotesActaAPI();

    const infraccionesRadarApi = useInfraccionesRadarAPI();
    const refFiltroInfracciones = useRef<FiltroInfraccionesRef>(null!);
    const refTable = useRef<DataTableRef>(null!);

    const [tipoExportacion, setTipoExportacion] = useState<TipoExportacion>("PROTOCOLO_BA");

    const [query, setQuery] = useState<Query>();
    const [total, setTotal] = useState<number>();
    const [loading, setLoading] = useState(false);
    const [nroLoteFilterForm] = Form.useForm();

    const generateLoteActa = async () => {

        setLoading(true);
        const response = await api.generateLoteActa(query!, tipoExportacion!);
        setLoading(false);
        if (response.error) {
            notification.error({
                message: "Error al generar el lote de exportación"
            });
        }
        else {
            await refFiltroInfracciones.current.loadTotal();
            await refTable.current.loadItems();
        }

        if (!Array.isArray(response.data?.value)) {
            window.location.href = response.data!.value;
        }
    };

    const generateFilters = (filters: Record<string, FilterValue | null>) => {

        return [
            filters?.NroLote != null ? `NroLote eq ${filters!.NroLote![0]}` : "",

        ];
    }


    return (
        <MainLayout >

            <Space size={"large"} direction="vertical">

                <FiltroInfracciones
                    ubicacionInfractorFilter
                    ref={refFiltroInfracciones}
                    onChange={(query) => {
                        setQuery(query);
                    }}
                    onChangeCount={(count) => {
                        setTotal(count);
                    }}
                    onChangeLoading={(loading) => {
                        setLoading(loading);
                    }}
                    count={async (query) => {
                        if (!tipoExportacion)
                            return;
                        return await infraccionesRadarApi.getVerificadasCount(tipoExportacion!, query);
                    }}
                    onChangeUnidadesProd={(ids) => {}}
                >
                    {/*refFiltroInfracciones?.current?.loadTotal() */}


                    <Select<TipoExportacion>
                        value={tipoExportacion}
                        onChange={(value) => {
                            setTipoExportacion(value);
                            refFiltroInfracciones?.current?.loadTotal();
                        }}
                        placeholder="Tipo de exportacion" style={{ width: "150px" }}>
                        <Select.Option value={"PROTOCOLO_BA" as TipoExportacion}>Protocolo BS. AS.</Select.Option>
                    </Select>

                    <Button
                        loading={loading}
                        type="primary"
                        onClick={generateLoteActa}
                        disabled={(total ?? 0) == 0 || !tipoExportacion}
                        icon={<FilePdfOutlined />}
                    >
                        Generar
                    </Button>
                </FiltroInfracciones>
                <DataTable<LoteExportacion, LoteExportacion>
                    list={(query) => api.list({
                        ...query,
                        ...{
                            $expand: ["ExportacionBA"]
                        }
                    })}
                    delete={async (id) => {
                        const result = await api.delete(id);
                        await refFiltroInfracciones.current.loadTotal();
                        return result;
                    }}
                    deleteMultipleAction
                    defaultSortOrder={"NroLote desc"}
                    selectionType='checkbox'
                    title={"Lotes de exportación"}
                    generateFilters={generateFilters}
                    deleteItemAction
                    deleteItemActionConfirmMessage={(item) => `¿Eliminar lote ${item.NroLote}?`}
                    defaultPageSize={5}
                    itemActions={[
                        {
                            key: 'download',
                            label: "Descargar",
                            //checkDisabled: (selectedItems, index, items) => !items?.at(index)?.UrlLoteComprimido,
                            action: (item) => {
                                window.location.href = item.TipoExportacion == "PROTOCOLO_BA" ? item.ExportacionBA!.FullUrl : item.UrlLoteComprimido!;
                            },
                            icon: <DownloadOutlined />
                        }
                    ]}
                    ref={refTable}

                >

                    <Table.Column<LoteExportacion>
                        width={`20%`}
                        title="Fecha"
                        dataIndex={"FechaHora"}
                        sorter
                        render={(value, record, index) => moment(value).format("DD/MM/YYYY HH:mm:ss")}
                        sortDirections={["ascend", "descend", "ascend"]}

                    />

                    <Table.Column<LoteExportacion>
                        width={`25%`}
                        title="Nro. de lote"
                        dataIndex={"NroLote"}
                        sorter
                        defaultSortOrder={'descend'}
                        sortDirections={["ascend", "descend", "ascend"]}
                        filterDropdown={(props) => {
                            return (
                                <DataFilter filterDropdownProps={props} form={nroLoteFilterForm} >
                                    <Form.Item name={"NroLote"} style={{ marginBottom: 10 }}>
                                        <Input placeholder='Nro. de lote...' />
                                    </Form.Item>
                                </DataFilter>
                            );
                        }
                        }

                    />

                    <Table.Column<LoteExportacion>
                        width={`20%`}
                        title="Cantidad"
                        dataIndex={"CantidadInfracciones"}
                        sorter
                        sortDirections={["ascend", "descend", "ascend"]}

                    />
                    <Table.Column<LoteExportacion>
                        width={`20%`}
                        title="Tipo"
                        render={(value, record, index) => {
                            return `${{
                                "NO_EXPORTA": "Sin exportación",
                                "PROTOCOLO_BA": "Protocolo Buenos Aires"
                            }[record.TipoExportacion]}`;
                        }}
                    />
                </DataTable>
            </Space>


        </MainLayout>
    );

};